import React from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import useUpdateQueryParams from "@/hooks/use-update-query-params";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import useOnboardingData from "@/store/onboarding-data";
import Cookies from "js-cookie";
import {useCloseAgentChat} from "@/api/agent-chat/useCloseAgentChat.tsx";

interface ChatRequestProps {
    name: string;
    image?: string;
    lastMessage: string;
    active?: boolean;
    id: string;
    index?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    connectWebSocket?: any;
    sendMessage: any;
    isConnected?: boolean;
}

const ChatRequest: React.FC<ChatRequestProps> = ({ name, image, lastMessage, active = false, id, index, connectWebSocket, sendMessage, isConnected }) => {

    const updateQueryParams = useUpdateQueryParams();
    // const handleClick = () => {
    //     updateQueryParams({ chat_id: id });
    // };

    const {mutate} = useCloseAgentChat()

    const { storeData, userData } = useOnboardingData()

    const handleConnect = () => {
        console.log("Chat is ready!");
        sendMessage(`Hello there, this is ${userData?.name}. I am here to help with your query. How can I assist you?`);
    };

    // const { connectWebSocket, sendMessage, messages, isConnected } = useAgentChatSocket();

    const handleAcceptRequest = () => {
        // Implement logic to accept the chat request
        updateQueryParams({ chat_id: id });
        if (connectWebSocket) {
            connectWebSocket({
                storeId: storeData?.id,
                agentId: userData?.id,
                requestId: id,
                token: Cookies.get(import.meta.env.VITE_KINDE_ACCESS_TOKEN || "kinde_access_token") || "",
                onConnect: handleConnect,
            }); // Call the connectWebSocket function
        }
    };

    const handleDisconnect = () => {
        sendMessage(`This chat is now terminated by ${userData?.name}. Hope this conversation was helpful.`);
        mutate({request_id: id})
    }


    return (
        <button
            // onClick={handleClick}
            className={cn(
                active ? "bg-blue-50" : "bg-white",
                "transition duration-200 hover:bg-blue-50",
                "mb-2 min-w-auto md:min-w-28 flex md:flex-col lg:flex-row items-center  justify-center md:justify-normal gap-0 md:gap-4 rounded-lg p-3 text-start w-full"
            )}
        >
            <Avatar>
                <AvatarImage src={image} alt={name} />
                <AvatarFallback>{index || 0 + 1}</AvatarFallback>
            </Avatar>
            <div className="hidden text-start md:block md:text-center lg:text-start">
                <h6 className="line-clamp-1 font-semibold">{name}</h6>
                <div className="hidden lg:inline-flex">
                    <p className="line-clamp-1  text-gray-500 ">{lastMessage}</p>
                </div>
                <div className="flex justify-end items-center mt-2">
                    {isConnected ? (

                    <Button size={"sm"} className="bg-red-600 hover:bg-red-700 cursor-pointer" onClick={handleDisconnect}>Disconnect</Button>
                    ) : (
                    <Button size={"sm"} className="bg-green-600 hover:bg-green-700 cursor-pointer" onClick={handleAcceptRequest}>Accept Request</Button>

                    )}
                </div>
            </div>
        </button>
    );
};

export default ChatRequest;
